import { CLIENT_LOGOS } from "../../content";

export const Marquee = ({ t }) => {
  const words = t.marquee;
  return (
    <section className="py-12 md:py-16 border-y border-line bg-secondary/50" data-testid="keywords-band">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
          {words.map((w, i) => (
            <span key={i} className="flex items-center">
              <span className="font-accent italic text-3xl md:text-5xl text-green">{w}</span>
              {i < words.length - 1 && (
                <span className="text-accent text-xl md:text-2xl ml-4 md:ml-4">&mdash;</span>
              )}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export const TrustedBy = ({ t }) => (
  <section className="max-w-7xl mx-auto px-6 md:px-12 py-10 md:py-14" data-testid="trusted-by">
    <p className="text-xs uppercase tracking-[0.22em] font-bold text-muted mb-6">{t.trusted.label}</p>
    <div className="bg-surface border border-line px-6 md:px-12 py-7 md:py-8">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-x-8 gap-y-8 items-center justify-items-center">
        {CLIENT_LOGOS.map((c) => (
          <img
            key={c.file}
            src={`${process.env.PUBLIC_URL}/logos/${c.file}.png`}
            alt={`${c.name} logo`}
            data-testid={`client-logo-${c.file}`}
            className="h-12 md:h-16 w-auto object-contain opacity-95 hover:opacity-100 hover:scale-[1.04] transition-all duration-300"
          />
        ))}
      </div>
    </div>
  </section>
);
